import { apiClient } from "@/lib/api-client";

export type UnsurJabatanTambahanData = Record<string, any>;

export type UnsurJabatanTambahanResponse = {
  datas: UnsurJabatanTambahanData;
  message: string;
};

export const fetchUnsurJabatanTambahan = async ({
  niu,
  year,
  semester,
  periodeID,
}: {
  niu: string;
  year: number;
  semester: number;
  periodeID?: number | null;
}): Promise<UnsurJabatanTambahanData> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const params = new URLSearchParams({
    year: year.toString(),
    semester: semester.toString(),
    ...(periodeID && { periodeID: periodeID.toString() }),
  });

  const resData = await apiClient<UnsurJabatanTambahanResponse>(
    `${baseUrl}/api/v1/unsur-jabatan-tambahan/${niu}?${params.toString()}`,
    {
      headers: {
        Accept: "application/json",
      },
    }
  );

  return resData.datas;
};
